import React from "react";
import Submission from "../components/Submission";
import LocationOnIcon from '@mui/icons-material/LocationOn';
import Conference from "../components/Conference";
import Partners from '../components/Partners';
import Host from '../components/Host';
import CoHost from '../components/CoHost';
import OrganisingCommitteeChair from '../components/OrganisingCommitteeChair';
import AdvisoryTeamChairs from '../components/AdvisoryTeamChair';
import Agenda from '../components/Agenda';

const Home = () => {
  return (
    <>
      <div className="cover">
        <div className="overlay">
          <div className="title">
            <h3 className="md:text-5xl text-3xl mt-4">
              International Conference on Advanced Manufacturing and Materials for Sustainable Mining Equipment and Technologies 2025
            </h3>
            <div>
              <h1 className="text-orange md:text-3xl md:mt-6 text-xl mt-4">
                29 September to 3 October 2025
              </h1>
              <span className="text-orange md:text-3xl md:mt-6 text-xl mt-4">
                <LocationOnIcon /> Wollongong, NSW, AUSTRALIA
              </span>
            </div>
            <p className="text-center text-sm sm:text-md md:text-xl px-4">
              Designed to bring together practitioner and researchers as well as the broader community engineering professionals who are interested in composite materials manufacturing, designing of advanced materials, tribology, design of advanced mining equipment, this Conference will showcase numerous presentations addressing innovative technologies, new research outcomes of significant industry impact, state-of-the-art practices related to site investigations, monitoring and instrumentation, and case histories in the relevant areas.
            </p>
          </div>
        </div>
      </div>

      <Conference />
      <Submission />

      {/* Updated Programme Heading with Download */}
      <div className="flex items-center gap-4 px-4 mt-8">
        <h1 className="text-light-orange uppercase text-xl md:text-3xl font-bold">Programme</h1>
        <a
          href="/AMMET2025Program.pdf"
          download
          className="text-white bg-gradient-to-r from-blue-600 to-blue-800 hover:from-blue-700 hover:to-blue-900 font-semibold text-sm rounded-lg px-4 py-2 shadow-md transition-all duration-200 ease-in-out"
        >
          ⬇ Download Program Detail
        </a>
      </div>

      <Agenda />

      <h1 className="text-light-orange uppercase text-xl md:text-3xl font-bold">Hosts</h1>
      <Host />

      <h1 className="text-light-orange uppercase text-xl md:text-3xl font-bold">Co-Hosts</h1>
      <CoHost />

      <h1 className="text-light-orange uppercase text-xl md:text-3xl font-bold">Organising Committee Chairs</h1>
      <OrganisingCommitteeChair />

      <h1 className="text-light-orange uppercase text-xl md:text-3xl font-bold">Advisory Committee Chairs</h1>
      <AdvisoryTeamChairs />

      <div className="m-4">
        <h1 className="text-light-orange uppercase text-xl md:text-3xl font-bold">Sponsors</h1>
        <Partners />
      </div>
    </>
  );
};

export default Home;